import { render, staticRenderFns } from "./OptionShowSubelementsTab.vue?vue&type=template&id=55d6bc7a"
import script from "./OptionShowSubelementsTab.vue?vue&type=script&lang=ts"
export * from "./OptionShowSubelementsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports